import { createContext, useContext, useState, ReactNode } from 'react';
import { NotificationData } from '../interfaces/notificationData';

interface NotificationContextType {
  notification: NotificationData | null;
  setNotification: (notification: NotificationData | null) => void;
  resetNotification: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider = ({ children }: { children: ReactNode }) => {
  const [notification, setNotification] = useState<NotificationData | null>(null);

  const resetNotification = () => {
    setNotification((current) => {
      if (current?.useModal === true && current?.duration === 0) {
        return current;
      }
      
      const duration = current?.duration || 3000;
      setTimeout(() => {
        setNotification(null);
      }, duration);
      
      return current;
    });
  };

  return (
    <NotificationContext.Provider
      value={{
        notification,
        setNotification,
        resetNotification,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};
